import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormRadioMultiContainerPreview({ children, ...props }) {
  return <BasePreview {...props}>
    <div>
      {children}
    </div>
  </BasePreview>
}

export default define('form-radio-multi-container', FormRadioMultiContainerPreview, Fragment)
  .shared(prop.share('FormRadioMultiContainer', 'form-radio-multi-container'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    textAlign: {
      vertical: 'middle',
    },
  })
  .build()
